// One lesson on the dashboard: what it is about, how much of its phrase list has
// been drilled, whether there is narration to listen to, and when it was last
// practised.

import { Link } from "react-router-dom";

/** "today" / "yesterday" / "3 days ago" / "12 Aug" — recency, not a timestamp. */
function relativeDay(iso) {
  if (!iso) return "never practised";
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return "never practised";
  const days = Math.floor((Date.now() - then.getTime()) / 86400000);
  if (days <= 0) return "practised today";
  if (days === 1) return "practised yesterday";
  if (days < 7) return `practised ${days} days ago`;
  return `practised ${then.toLocaleDateString(undefined, { day: "numeric", month: "short" })}`;
}

export default function LessonCard({ lesson }) {
  const { slug, title, theme, phrase_count: total, practiced, has_audio: hasAudio } = lesson;
  const pct = total ? (practiced / total) * 100 : 0;
  const done = total > 0 && practiced >= total;

  return (
    <Link
      to={`/english/${encodeURIComponent(slug)}`}
      className="group flex flex-col rounded-xl border border-slate-800 bg-slate-900/40 p-4 transition hover:border-sky-500/40 hover:bg-slate-900/80"
    >
      <div className="flex items-start justify-between gap-3">
        <h2 className="text-sm font-semibold text-slate-100 transition group-hover:text-sky-300">
          {title}
        </h2>
        {done && (
          <span className="shrink-0 rounded-full bg-emerald-500/15 px-2 py-0.5 text-[10px] font-medium text-emerald-400">
            complete
          </span>
        )}
      </div>

      {theme && <p className="mt-1 line-clamp-2 text-xs text-slate-500">{theme}</p>}

      <div className="mt-4 flex items-center gap-2">
        <div className="h-1 flex-1 overflow-hidden rounded-full bg-slate-800">
          <div
            className="h-full rounded-full bg-emerald-500 transition-all"
            style={{ width: `${pct}%` }}
          />
        </div>
        <span className="shrink-0 text-[11px] tabular-nums text-slate-500">
          {practiced}/{total}
        </span>
      </div>

      {/* One line per fact when the card is narrow: these are short labels, and
          letting them wrap mid-phrase leaves orphaned separator dots. */}
      <div className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-slate-600">
        <span className={`whitespace-nowrap ${hasAudio ? "text-slate-500" : "text-slate-700"}`}>
          {hasAudio ? "🔊 audio" : "no audio"}
        </span>
        <span className="whitespace-nowrap">· {relativeDay(lesson.last_practiced)}</span>
        {lesson.sessions > 0 && (
          <span className="whitespace-nowrap">
            · {lesson.sessions} session{lesson.sessions === 1 ? "" : "s"}
          </span>
        )}
      </div>
    </Link>
  );
}
